import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '69视频',
  url: 'https://woaimiao.cn/',
  description: '69视频平台提供西瓜视频免费、91在线视频等影视在线观看入口，海量电影大全、电视剧全集、综艺节目高清播放不卡顿。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-6969',
    contactType: 'customer service',
    email: 'contact@69shipin.com',
    availableLanguage: ['Chinese'],
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '光华路69号',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    addressCountry: 'CN',
  },
};

export default function About() {
  return (
    <>
      <SEOHead
        title="关于我们 - 69视频 | 品牌介绍与联系方式"
        description="69视频平台品牌介绍，了解我们的发展历程、核心优势、用户口碑和联系方式。专业的免费影视在线观看平台。"
        keywords="69视频,关于我们,品牌介绍,联系方式,影视平台"
        canonicalUrl="https://woaimiao.cn/about"
        structuredData={orgSchema}
      />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-[900px] mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading text-center">
              关于69视频
            </h1>
            <p className="mt-4 text-sm text-foreground-500 text-center max-w-2xl mx-auto">
              致力于为广大影迷打造最优质的免费影视在线观看平台
            </p>

            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-play-circle-line text-2xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 font-heading">海量资源</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  汇聚超过10万部电影、电视剧、综艺、动漫、纪录片等高清影视资源，每日更新1000+内容。
                </p>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 font-heading">高清流畅</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  采用先进的视频压缩与CDN加速技术，支持1080P至4K超高清画质，播放流畅不卡顿，99.9%的播放成功率。
                </p>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200 text-center">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-user-heart-line text-2xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-800 font-heading">完全免费</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  无需注册、无需付费，所有内容免费在线观看。我们致力于让每一个人都能轻松享受高品质的影视娱乐。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-[900px] mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center">
              品牌故事
            </h2>

            <div className="mt-8 space-y-6">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200">
                <h3 className="text-lg font-semibold text-foreground-800 font-heading mb-3">
                  <i className="ri-calendar-line text-primary-500 mr-2"></i>
                  我们的起点
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  69视频诞生于对影视热爱的初心。创始团队由一群资深影迷和互联网技术专家组成，我们深知寻找高质量影视资源的困难——要么需要付费订阅多个平台，要么面临画质差、广告多的糟糕体验。因此，我们决定打造69视频：一个汇聚全网优质影视资源的免费平台。
                </p>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200">
                <h3 className="text-lg font-semibold text-foreground-800 font-heading mb-3">
                  <i className="ri-rocket-line text-primary-500 mr-2"></i>
                  快速发展
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  自上线以来，69视频以惊人的速度成长。从最初的几百部影片，到如今超过10万部影视资源库；从日活几百用户，到如今超过5000万活跃用户。我们持续优化技术架构，引入CDN全球加速节点，确保无论用户身在何处，都能享受流畅的高清观影体验。我们的视频资源涵盖西瓜视频免费、91在线视频等热门影视入口。
                </p>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200">
                <h3 className="text-lg font-semibold text-foreground-800 font-heading mb-3">
                  <i className="ri-eye-line text-primary-500 mr-2"></i>
                  未来愿景
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  展望未来，69视频将继续坚持"免费、高清、流畅"的核心理念，不断丰富影视资源库，提升播放体验。我们计划引入AI智能推荐系统，让每一位用户都能轻松发现自己喜爱的内容。同时，我们也在积极拓展海外市场，将优秀的华语影视内容带给全球观众。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-[900px] mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center">
              用户口碑
            </h2>
            <p className="mt-2 text-sm text-foreground-500 text-center">
              来自真实用户的使用评价
            </p>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="p-5 rounded-xl bg-background-50 border border-background-200">
                <div className="flex items-center gap-1 text-accent-500 mb-3">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  "69视频真的太方便了！不用下载任何APP，打开网页就能看高清电影，而且更新速度超快。西瓜视频免费的内容这里都有，强烈推荐！"
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                    <span className="text-xs font-semibold text-primary-600 font-label">张</span>
                  </div>
                  <div>
                    <p className="text-xs font-medium text-foreground-800">张先生</p>
                    <p className="text-xs text-foreground-500">忠实用户 · 使用2年</p>
                  </div>
                </div>
              </div>

              <div className="p-5 rounded-xl bg-background-50 border border-background-200">
                <div className="flex items-center gap-1 text-accent-500 mb-3">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  "作为一个追剧狂人，69视频简直就是我的天堂。电视剧更新比视频网站还快，画质清晰还不卡顿。91在线视频的资源也很全，每天必刷！"
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <span className="text-xs font-semibold text-accent-600 font-label">李</span>
                  </div>
                  <div>
                    <p className="text-xs font-medium text-foreground-800">李女士</p>
                    <p className="text-xs text-foreground-500">追剧达人 · 使用1年</p>
                  </div>
                </div>
              </div>

              <div className="p-5 rounded-xl bg-background-50 border border-background-200">
                <div className="flex items-center gap-1 text-accent-500 mb-3">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  "纪录片爱好者必收！BBC和国家地理的资源都有，而且大部分是免费高清。69视频让我省了好多会员费，良心平台！"
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                    <span className="text-xs font-semibold text-secondary-600 font-label">王</span>
                  </div>
                  <div>
                    <p className="text-xs font-medium text-foreground-800">王先生</p>
                    <p className="text-xs text-foreground-500">纪录片迷 · 使用3年</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-[900px] mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center">
              联系我们
            </h2>
            <p className="mt-2 text-sm text-foreground-500 text-center">
              如有任何问题或合作意向，欢迎联系我们
            </p>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 font-heading mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-600">contact@69shipin.com</p>
                    <p className="text-xs text-foreground-500 mt-2">商务合作：biz@69shipin.com</p>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 font-heading mb-1">客服热线</h3>
                    <p className="text-sm text-foreground-600">400-888-6969</p>
                    <p className="text-xs text-foreground-500 mt-2">工作时间：周一至周日 9:00-21:00</p>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 font-heading mb-1">公司地址</h3>
                    <p className="text-sm text-foreground-600">北京市朝阳区光华路69号</p>
                    <p className="text-xs text-foreground-500 mt-2">国贸商务中心A座18层</p>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 font-heading mb-1">社交媒体</h3>
                    <p className="text-sm text-foreground-600">微信公众号：69视频</p>
                    <p className="text-xs text-foreground-500 mt-2">微博/抖音：@69视频官方</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}